import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import LabelText from '../../../IN/LabelText';
import FriendCountryCode from './FriendCountryCode';

const FriendMobile = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { friendIndex, form_component } = props;
	form_component.label = t('手機');
	const fv = useSelector(state => state.fv);
	const pageData = useSelector(state => state.pageData);
	const controller = pageData.controller;

	const [inputValue, setInputValue] = useState('');

	const registerField = () => {
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator && form_component.required) {
			const fieldName = `friend[${friendIndex}][mobile]`;
			
			try {
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						},
						regexp: {
							regexp: /(\d)+/i,
							message: t('手機格式錯誤')
						}
					},
					selector: `input[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => {
		registerField();
	}, [fv, controller, form_component.required, t, friendIndex]);

	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t, friendIndex]);

	const onChange = (e) => {
		const value = e.target.value;
		setInputValue(value);
		
		if (controller === 'Shopcarts') {
			const fieldName = `friend[${friendIndex}][mobile]`;
			const domElement = document.querySelector(`input[name="${fieldName}"]`);
			if (domElement) {
				domElement.setAttribute('value', value);
				domElement.value = value;
			}
		}
	}

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				form_component={form_component}
			/>
			<div className="input-group form-group flex-nowrap mb-3">
				<FriendCountryCode
					friendIndex={friendIndex}
					form_component={form_component}
				/>
				<input
					type="text"
					name={`friend[${friendIndex}][mobile]`}
					inputMode="numeric"
					placeholder={form_component.default_text_type === 'placeholder' ? form_component.default_text : ''}
					id={`friend-${friendIndex}-mobile`}
					className="form-control form-control-sm"
					value={inputValue}
					onChange={onChange}
				/>
			</div>
		</div>
	);
}

export default FriendMobile;
